import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

interface RootProps {
    inline?: boolean;
    width?: number | string;
}

export const Root = styled.div<RootProps>(props => ({
    marginTop: 4,
    color: theme(props).typography.secondary.color,
    lineHeight: theme(props).typography.primary.lineHeight.css(),
    display: props.inline ? "inline-block" : undefined,
    width: props.width,
}));
